import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "@/i18n";
import "./assets/styles/global.css";
import AOS from "aos";
import Vuelidate from "vuelidate";
import VueTheMask from "vue-the-mask";
import "@/plugins/global-components";
import "aos/dist/aos.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

const isProduction = process.env.NODE_ENV === 'production' || process.env.VUE_APP_ENV === 'production';

if (isProduction) {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
  console.table = noop;
  if (window.Sentry) {
    Vue.config.errorHandler = (err, vm, info) => {
      window.Sentry.captureException(err, {
        extra: { 
          component: vm.$options.name, 
          info,
          route: vm.$route?.path 
        }
      });
    };
  }
}

console.log('Environment:', {
  NODE_ENV: process.env.NODE_ENV,
  VUE_APP_ENV: process.env.VUE_APP_ENV,
  BASE_URL: process.env.BASE_URL
});


Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(VueToast);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
AOS.init();
